var app = angular.module("DSShopify", ["ui.bootstrap"]);
app.config([
  "$interpolateProvider",
  function ($interpolateProvider) {
    $interpolateProvider.startSymbol("{[{").endSymbol("}]}");
  },
]);
app.directive("focusout", [
  "$parse",
  function ($parse) {
    return {
      compile: function ($element, attr) {
        var fn = $parse(attr.focusout);
        return function handler(scope, element) {
          element.on("focusout", function (event) {
            scope.$apply(function () {
              fn(scope, { $event: event });
            });
          });
        };
      },
    };
  },
]);
app.factory("sideBarService", [
  "$parse",
  function ($parse) {
    var service = {};
    service.Items = [];
    service.setItems = function (items) {
      console.log("items", items);
      service.Items = items;
    };
    return service;
  },
]);
app.factory("calculateService", [
  function () {
    var service = {
      calculateOrderResponse: {},
      calculateAutoOrderResponse: {},
      createCheckoutResponse: {},
    };
    return service;
  },
]);
app.directive("enterPressed", function () {
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if (event.which === 13) {
        scope.$apply(function () {
          scope.$eval(attrs.enterPressed);
        });
        event.preventDefault();
      }
    });
  };
});
app
  .directive("validate", function () {
    return {
      restrict: "A",
      link: function (scope, element, attrs, rootScope) {
        element = $(element[0]);
        // var formcompletecheck = true;
        // var StopExecution = true;
        /*--Window Blur logic---*/

        /* Note: In Chrome - if focused on an input and then you blur out of the browser ie: Click on a different application - two blurs get called
			the input blur and window.blur - the following logic addresses this use case. A check for windowBlur happens in showErr() method below... */

        var windowBlur = false;
        $(window).on("blur", function () {
          windowBlur = true;
        });
        $(window).on("focus", function () {
          windowBlur = false;
        });

        var regexValidate = function (value, showError, regxExp, hostElement) {
          // let regxvalidvalue = "((?=.*\d)(?=.*[A-Z])(?=.*[a-z]).{10,})";

          var charfilter = new RegExp("(.{10,})");
          var casefilter = new RegExp("(?=.*[A-Z])(?=.*[a-z])");
          var numberfilter = new RegExp("(?=.*\\d)");
          var symbolfilter = new RegExp("(?=.*\\W)");

          if (charfilter.test(value)) {
            scope.$root.stantdardPassReq["character"] = true;
          } else {
            scope.$root.stantdardPassReq["character"] = false;
            if (showError) showInvalidPassword(0, hostElement);
          }

          if (casefilter.test(value)) {
            scope.$root.stantdardPassReq["case"] = true;
          } else {
            scope.$root.stantdardPassReq["case"] = false;
            if (showError) showInvalidPassword(0, hostElement);
          }

          if (numberfilter.test(value)) {
            scope.$root.stantdardPassReq["number"] = true;
          } else {
            scope.$root.stantdardPassReq["number"] = false;
            if (showError) showInvalidPassword(0, hostElement);
          }

          if (symbolfilter.test(value)) {
            scope.$root.stantdardPassReq["symbol"] = true;
            showSuccess(hostElement);
          } else {
            scope.$root.stantdardPassReq["symbol"] = false;
            if (showError) showInvalidPassword(0, hostElement);
          }
          scope.$apply();
        };

        element.on("focus", function () {
          //on focus remove all visible error states/msgs
          element.closest(".control-group").removeClass("has-error");
          element.closest(".control-group").find(".has-error").remove();
          element.parent(".ds-validate").removeClass("ds-validate--has-error");
          element.parent(".ds-validate").find(".has-error").remove();
          element.find("state-error").remove();
          element.removeClass("state-error");
          element.removeClass("state-success");
          element.find("state-success").remove();
        });

        element.on("focusout", function () {
          element.parent(".ds-validate").removeClass("ds-validate--has-error");
          element.parent(".ds-validate").find(".has-error").remove();
        });

        /*---Cancel Validation Logic--*/
        //debugger;
        var cancelBox = element.closest(".controls").find(".cancel-validation");
        cancelBox.click(function () {
          element.toggleClass("novalidate");

          if ($(this).is(":checked")) {
            element.closest(".control-group").removeClass("has-error");
            element.closest(".control-group").find(".has-error").remove();
            element.closest(".control-group").hide();
            scope.$apply(attrs.updateId);
          } else {
            element.closest(".control-group").show();
          }
        });

        element.on("blur", function () {
          checkForm(element, 0);
        });

        element.keypress("keydown keypress", function (e) {
          if (element.attr("inputspace")) {
            var altkeypress;
            if (e.altKey) {
              altkeypress = true;
            } else {
              if (altkeypress) {
                altkeypress = false;
                return false;
              }
            }

            if (
              e.which === 32 ||
              e.which === 33 ||
              e.which === 34 ||
              e.which === 35 ||
              e.which === 36 ||
              e.which === 37 ||
              e.which === 38 ||
              e.which === 39 ||
              e.which === 40 ||
              e.which === 41 ||
              e.which === 42 ||
              e.which === 43 ||
              e.which === 44 ||
              e.which === 46 ||
              e.which === 47 ||
              e.which === 45 ||
              e.which === 58 ||
              e.which === 59 ||
              e.which === 60 ||
              e.which === 61 ||
              e.which === 62 ||
              e.which === 63 ||
              e.which === 64 ||
              e.which === 91 ||
              e.which === 93 ||
              e.which === 92 ||
              e.which === 94 ||
              e.which === 95 ||
              e.which === 96 ||
              e.which === 123 ||
              e.which === 124 ||
              e.which === 125 ||
              e.which === 126
            ) {
              return false;
            }
          }
          if (element.attr("inputonlynumber")) {
            if (
              (e.which >= 32 && e.which <= 47) ||
              e.which === 58 ||
              e.which === 59 ||
              e.which === 60 ||
              e.which === 61 ||
              e.which === 62 ||
              e.which === 63 ||
              e.which === 64 ||
              (e.which <= 122 && e.which >= 65) ||
              e.which === 123 ||
              e.which === 124 ||
              e.which === 125 ||
              e.which === 126
            ) {
              return false;
            }
          }
          if (element.attr("inputmobilespacendash")) {
            if (
              e.which === 33 ||
              e.which === 34 ||
              e.which === 35 ||
              e.which === 36 ||
              e.which === 37 ||
              e.which === 38 ||
              e.which === 39 ||
              e.which === 40 ||
              e.which === 41 ||
              e.which === 42 ||
              e.which === 43 ||
              e.which === 44 ||
              e.which === 46 ||
              e.which === 47 ||
              e.which === 58 ||
              e.which === 59 ||
              e.which === 60 ||
              e.which === 61 ||
              e.which === 62 ||
              e.which === 63 ||
              e.which === 64 ||
              e.which === 91 ||
              e.which === 93 ||
              e.which === 92 ||
              e.which === 94 ||
              e.which === 95 ||
              e.which === 96 ||
              e.which === 123 ||
              e.which === 124 ||
              e.which === 125 ||
              e.which === 126
            ) {
              return false;
            }
          }
          if (element.attr("validate-maxlength")) {
            var attr = element.attr("validate-maxlength");
            if (element.val().length + 1 > attr) {
              var customErrorMessgae = element.attr("error-message");
              element.closest(".control-group").find(".has-error").remove();
              if (customErrorMessgae) {
                showError(customErrorMessgae, element, attr);
              } else {
                showError("Max Character Allowed", element, attr);
              }
            } else {
              showSuccess(element);
            }
          }
          if (element.attr("inputspacehypens")) {
            if (e.which === 32 || e.which === 45) {
              return false;
            }
          }
          if (element.attr("nospaceallow")) {
            if (e.which === 32) {
              return false;
            }
          }
        });

        element.keydown("keydown", function (e) {
          if (
            (e.which == 8 || e.which == 46) &&
            element.attr("validate-maxlength")
          ) {
            element.parent(".ds-validate").find(".has-error").remove();
          }
          if (element.attr("regxvalid")) {
            if (element.val()) {
              regexValidate(
                element.val(),
                false,
                element.attr("regxvalidValue"),
                element
              );
            }
          }
        });

        var checkForm = function (element, type) {
          var attr;
          var value = element.val();

          /*--attrs is not used because when the continue button is clicked attrs held the value of the button and not the element we passsed in - instead
				we check the old fashioned way with jQuery to see what validation needs to be done.--*/

          //not empty validation
          if (element.attr("noempty")) {
            if ($.trim(value) === "") {
              if (type === 0) {
                element.closest(".control-group").find(".has-error").remove();
                showError("This field is Required", element);
              }
            } else {
              showSuccess(element);
            }
          }

          if (element.attr("ValidName")) {
            if (value.match(/[*^|":<>[\]{}\\()';?/~!,]/)) {
              if (type === 0) {
                showError("Special Character Not Allowed", element);
              }
            } else {
              showSuccess(element);
            }
          }

          if (element.attr("phoneno")) {
            if (!value.match(/^\d*$/)) {
              if (type === 0) {
                showError("Only Number Allow", element);
              }
            }
          }
          //min length validation
          if (element.attr("minlength")) {
            attr = element.attr("minlength");
            if (value) {
              if (value.length < attr) {
                if (type === 0) {
                  element
                    .closest(".ds-validate")
                    .addClass("ds-field--is-dirty");
                  showError("Minimum Charcater Required", element, attr);
                }
              } else {
                showSuccess(element);
              }
            }
          }

          //max length validation
          if (element.attr("validate-maxlength")) {
            attr = element.attr("validate-maxlength");
            if (value.length > attr) {
              if (type === 0) {
                var customErrorMessgae = element.attr("error-message");
                if (customErrorMessgae) {
                  showError(customErrorMessgae, element, attr);
                } else {
                  showError("error_maxlength_chars", element, attr);
                }
              }
            } else {
              showSuccess(element);
            }
          }
          //email validation
          if (element.attr("email")) {
            if (value) {
              validateEmail(value);
            }
          }
          function validateEmail(value) {
            var filter = new RegExp(
              "^([\\w-\\.+]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\\]?)$"
            );
            if (filter.test(value)) {
              showSuccess(element);
            } else {
              if (type === 0) {
                showError("Not Valid Email", element);
              }
            }
          }

          // alphanumeric validation
          if (element.attr("alphanumericdash")) {
            if (value) {
              validateAlphaNumericDash(value);
            }
          }

          function validateAlphaNumericDash(value) {
            var filter = new RegExp("^[a-zA-Z0-9]+$");
            if (filter.test(value)) {
              showSuccess(element);
            } else {
              if (type === 0) {
                showError("Only Alpha Numeric Value Allow", element);
              }
            }
          }

          if (element.attr("password-match")) {
            var currentPw = $("#txtPassword").val();
            if (element.val()) {
              if (currentPw == element.val()) {
                showSuccess(element);
              } else {
                if (type === 0) {
                  element.closest(".control-group").find(".has-error").remove();
                  showError("Password Not Match", element, attr);
                }
              }
            }
          }

          if (element.attr("email-match")) {
            var currentEID = $("#txtEmailAdd").val();
            if (element.val()) {
              if (currentEID == element.val()) {
                showSuccess(element);
              } else {
                if (type === 0) {
                  element.closest(".control-group").find(".has-error").remove();
                  showError("Email Not Matched!", element, attr);
                }
              }
            }
          }

          //no spaces
          if (element.attr("nospaces")) {
            if (value.match(/\s/g)) {
              if (type === 0) {
                element.closest(".control-group").find(".has-error").remove();
                showError("Space Not Allow", element);
              }
            } else {
              showSuccess(element);
            }
          }
          //select validation
          if (element.attr("validate-select")) {
            value = element.find("option:selected").text();

            if (value.match(/Select a/) || value === "") {
              if (type === 0) {
                showError("Please Make a Selection", element);
              }
            } else {
              showSuccess(element);
            }
          }

          //select validation
          if (element.attr("validate-custom-select")) {
            value = $("#freq_dd").val();

            if (value === "") {
              if (type === 0) {
                showError("Please Make a Selection", element);
              }
              // else {
              //     formcompletecheck = false;
              // }
            } else {
              showSuccess(element);
            }
          }

          //checkbox validation
          if (element.attr("checkbox-validate")) {
            if (!element.is(":checked")) {
              if (type === 0) {
                showError("Checkbox Required", element.parent());
              }
            } else {
              showSuccess(element);
            }
          }
          //checkbox validation
          if (element.attr("checkbox-validate-autoship")) {
            if (!element.is(":checked") && element.hasClass("ischeck")) {
              if (type === 0) {
                showError("Autoship Required", element.parent());
              }
            } else {
              showSuccess(element);
            }
          }

          //regex validation
          if (element.attr("regxvalid")) {
            if (value) {
              regexValidate(value, true, element.attr("regxvalidValue"), element);
            }
          }

          //regex validation
          if (element.attr("regxvalidzip")) {
            if (value) {
              regexValidateZip(
                value,
                element.attr("regexcountry").toUpperCase()
              );
            }
          }
          function regexValidateZip(value, countrycode) {
            var regxExp = ""; //regexService.getRegex(countrycode);
            var filter = new RegExp(regxExp);
            if (filter.test(value)) {
              showSuccess(element);
            } else {
              if (type === 0) {
                showError("INVALID ZIP", element);
              }
            }
          }

          //greater than zero
          if (element.attr("greater-than-zero")) {
            if (value) {
              var number = value.replace(/[^0-9]/g, "");
              if (number > 0) {
                showSuccess(element);
              } else {
                if (type === 0) {
                  showError("greater_then_zero", element, attr);
                }
              }
            }
          }
        };

        var showError = function (msg, element, value) {
          if (!element.hasClass("novalidate") && !windowBlur) {
            if (
              !element
                .closest(".control-group")
                .find("span")
                .hasClass("has-error")
            ) {
              //create and display error message
              element.removeClass("state-success");
              element.addClass("state-error");
              var container = $("<small />");

              if (element.attr("custommsg")) {
                msg = element.attr("custommsg");
              }

              msg = msg + " " + (value || "");
              console.log("msg", msg);
              container
                .text(msg)
                .addClass("has-error help-block ")
                .attr("translate", "");
              element.parent(".ds-validate").addClass("ds-validate--has-error");
              element
                .parent(".custom-validate")
                .addClass("custom-validate--has-error");

              if (
                element.hasClass("ds-checkbox") ||
                element.hasClass("ds-radio")
              ) {
                element.after(container);
              }
              if (element.parent().hasClass("ds-validate--has-error")) {
                element.after(container);
              }
              if (element.parent().hasClass("custom-validate--has-error")) {
                element.parent().after(container);
              }
              element.closest(".control-group").addClass("has-error");
            }
          }
        };
        var showSuccess = function (element) {
          if (!element.hasClass("novalidate") && !windowBlur) {
            if (
              !element
                .closest(".control-group")
                .find("span")
                .hasClass("has-error")
            ) {
              //create and display error message
              element.removeClass("state-error");
              element.addClass("state-success");
            }
          }
        };
        var showInvalidPassword = function (type, element) {
          if (type === 0) {
            element.closest(".control-group").find(".has-error").remove();
            showError(
              `
					Password doesn't meet minimum requirement!
					`,
              element
            );
          }
        };

        if (attrs.triggerCheck) {
          element.click(function (ev) {
            //  StopExecution = true;
            ev.preventDefault();
            //remove any visible errors
            $(".control-group.has-error").removeClass("has-error");
            $(".control-group").find(".has-error").remove();

            scope.$apply(attrs.pvCheck);
            var sectiontype = attrs["sectiontype"];

            //grab all inputs set for validation minus the button triggering the check
            var inputs = $("[" + sectiontype + "]").not(
              "input[trigger-checksection]"
            );

            //loop through inputs and send them through checkForm
            inputs.each(function (i, e) {
              var element = $(e);
              checkForm(element, 0);
            });

            var errors = $(".control-group.has-error");
            if (errors.length === 0) {
              scope.$apply(attrs.success);
            } else {
              var target = $(".control-group.has-error")[0];
              $("html, body").animate(
                {
                  scrollTop: $(target).offset().top - 100,
                },
                1000
              ); //animate scroll to first error
            }
          });
        }
        if (attrs.triggerWithoutScroll) {
          element.click(function (ev) {
            //  StopExecution = true;
            ev.preventDefault();
            //remove any visible errors
            $(".control-group.has-error").removeClass("has-error");
            $(".control-group").find(".has-error").remove();

            scope.$apply(attrs.pvCheck);
            var sectiontype = attrs["sectiontype"];

            //grab all inputs set for validation minus the button triggering the check
            var inputs = $("[" + sectiontype + "]").not(
              "input[trigger-checksection]"
            );

            //loop through inputs and send them through checkForm
            inputs.each(function (i, e) {
              var element = $(e);
              checkForm(element, 0);
            });

            var errors = $(".control-group.has-error");
            if (errors.length === 0) {
              scope.$apply(attrs.success);
            }
          });
        }

        if (attrs.triggerChecksection) {
          element.click(function (ev) {
            //StopExecution = true;
            ev.preventDefault();
            //remove any visible errors
            $(".control-group.has-error")
              .not(".ccvalidation, .sumlength")
              .removeClass("has-error");
            $(".control-group")
              .not(".ccvalidation, .sumlength")
              .find(".has-error")
              .remove();

            scope.$apply(attrs.pvCheck);
            var sectiontype = attrs["sectiontype"];

            //grab all inputs set for validation minus the button triggering the check
            var inputs = $("[" + sectiontype + "]")
              .not("input[trigger-checksection]")
              .not(".novalidate");

            //loop through inputs and send them through checkForm
            inputs.each(function (i, e) {
              var element = $(e);
              checkForm(element, 0);
            });

            //special pw check that happens only on btn click and if pw field exists
            if ($("#password1").length > 0) {
              var pw1 = $("#password1");
              var pw2 = $("#password2");
              var ctrlGrps = pw1
                .closest(".controls-row")
                .find(".control-group");
              if (pw1.val() !== pw2.val()) {
                ctrlGrps.addClass("has-error");
                $(".password-match").text("No Match").addClass("has-error");
              }
            }

            //special ew check that happens only on btn click and if ew field exists
            if ($("#emailAdd1").length > 0) {
              var ew1 = $("#emailAdd1");
              var ew2 = $("#emailAdd2");
              var ctrlGrps = ew1
                .closest(".controls-row")
                .find(".control-group");
              if (ew1.val() !== ew2.val()) {
                ctrlGrps.addClass("has-error");
                $(".password-match").text("No Match").addClass("has-error");
              }
            }

            var errors = $(".control-group.has-error");
            if (errors.length === 0) {
              scope.$apply(attrs.success);
            } else {
              var target = $(".control-group.has-error")[0];
              var link = $(target);
              var offset = link.offset();
              var top = offset.top;
              var bottom = $(window).height() - top - link.height();
              $("html, body").animate(
                {
                  scrollTop: bottom > 1 ? bottom : $(target).offset().top,
                },
                1000
              ); //animate scroll to first error
            }
          });
        }
        if (attrs.triggerTabSection) {
          element.click(function (ev) {
            setTimeout(function () {
              //StopExecution = true;
              ev.preventDefault();
              //remove any visible errors

              var sections = $("div[trigger-tab-section='true']").not(
                "[currenttab='true']"
              );
              sections.each(function (n, item) {
                var element1 = $(item);
                //grab all inputs set for validation minus the button triggering the check
                var inputs = element1.find(":input");

                //loop through inputs and send them through checkForm
                inputs.each(function (i, e) {
                  var element = $(e);
                  element.closest(".control-group").removeClass("has-error");
                  element.closest(".control-group").find(".has-error").remove();

                  checkForm(element, 0);
                });
              });
              //special pw check that happens only on btn click and if pw field exists
              if ($("#password1").length > 0) {
                var pw1 = $("#password1");
                var pw2 = $("#password2");
                var ctrlGrps = pw1
                  .closest(".controls-row")
                  .find(".control-group");
                if (pw1.val() !== pw2.val()) {
                  ctrlGrps.addClass("has-error");
                  $(".password-match").text("No Match").addClass("has-error");
                }
              }

              //special ew check that happens only on btn click and if ew field exists
              if ($("#emailAdd1").length > 0) {
                var ew1 = $("#emailAdd1");
                var ew2 = $("#emailAdd2");
                var ctrlGrps = ew1
                  .closest(".controls-row")
                  .find(".control-group");
                if (ew1.val() !== ew2.val()) {
                  ctrlGrps.addClass("has-error");
                  $(".password-match").text("No Match").addClass("has-error");
                }
              }
            }, 1000);
          });
          element.on("focusin", function (ev) {
            setTimeout(function () {
              //StopExecution = true;
              ev.preventDefault();
              //remove any visible errors
              //$('.control-group.has-error').removeClass('has-error');
              //$('.control-group').find('.has-error').remove();

              var sections = $("div[trigger-tab-section='true']").not(
                "[currenttab='true']"
              );
              sections.each(function (n, item) {
                var element1 = $(item);
                //grab all inputs set for validation minus the button triggering the check
                var inputs = element1.find(":input");

                //loop through inputs and send them through checkForm
                inputs.each(function (i, e) {
                  var element = $(e);
                  element.closest(".control-group").removeClass("has-error");
                  element.closest(".control-group").find(".has-error").remove();
                  checkForm(element, 0);
                });
              });
              //special pw check that happens only on btn click and if pw field exists
              if ($("#password1").length > 0) {
                var pw1 = $("#password1");
                var pw2 = $("#password2");
                var ctrlGrps = pw1
                  .closest(".controls-row")
                  .find(".control-group");
                if (pw1.val() !== pw2.val()) {
                  ctrlGrps.addClass("has-error");
                  $(".password-match").text("No Match").addClass("has-error");
                }
              }

              //special ew check that happens only on btn click and if ew field exists
              if ($("#emailAdd1").length > 0) {
                var ew1 = $("#emailAdd1");
                var ew2 = $("#emailAdd2");
                var ctrlGrps = ew1
                  .closest(".controls-row")
                  .find(".control-group");
                if (ew1.val() !== ew2.val()) {
                  ctrlGrps.addClass("has-error");
                  $(".password-match").text("No Match").addClass("has-error");
                }
              }
            }, 1000);
          });
        }
      },
    };
  })
  .filter("unique", [
    function () {
      return function (collection, keyname) {
        var output = [],
          keys = [];

        angular.forEach(collection, function (item) {
          var key = item[keyname];
          if (keys.indexOf(key) === -1) {
            keys.push(key);
            output.push(item);
          }
        });

        return output;
      };
    },
  ]);
app.controller("AppCtrl", [
  "$window",
  "$scope",
  "$rootScope",
  "$uibModal",
  "$compile",
  "$templateCache",
  "$location",
  "sideBarService",
  "calculateService",
  function (
    $window,
    $scope,
    $rootScope,
    $uibModal,
    $compile,
    $templateCache,
    $location,
    sideBarService,
    calculateService
  ) {
    $rootScope.ClientSettings = {};
    $.getJSON("/search?q=&view=clientsettings").then(function (response) {
      $rootScope.ClientSettings = response;
      $rootScope.$apply();
    });
    $rootScope.EnrollmentPack =
      $rootScope.EnrollmentPack ||
      JSON.parse(localStorage.getItem("cart.packs")) ||
      [];
    $rootScope.AutoshipItems =
      $rootScope.AutoshipItems ||
      JSON.parse(localStorage.getItem("cart.autoship")) ||
      [] ||
      [];
    $rootScope.BundlePack =
      $rootScope.BundlePack ||
      JSON.parse(localStorage.getItem("cart.bundle")) ||
      [];
    $rootScope.OrderItems =
      $rootScope.OrderItems ||
      JSON.parse(localStorage.getItem("cart.orderItems")) ||
      [];
    $rootScope.SponsorDetails =
      $rootScope.SponsorDetails ||
      JSON.parse(localStorage.getItem("sponserDetails"));

    $rootScope.showLoader = function () {
      $("#vjenroll-loading").css("display", "block");
    };
    $rootScope.hideLoader = function () {
      $("#vjenroll-loading").css("display", "none");
    };

    $rootScope.stantdardPassReq = {
      character: false,
      case: false,
      number: false,
      symbol: false,
    };

    $rootScope.isContainOrderItem = false;
    $rootScope.UserData = $rootScope.UserData || {};
    $scope.selectedFrequency = {};
    $scope.frequnecyStartDate = "";
    $rootScope.$watch(
      function () {
        return $window.localStorage.getItem("cart.packs");
      },
      function (newCodes, oldCodes) {
        $rootScope.EnrollmentPack = JSON.parse(newCodes) || [];
      }
    );
    $rootScope.$watch(
      function () {
        return $window.localStorage.getItem("cart.bundle");
      },
      function (newCodes, oldCodes) {
        $rootScope.BundlePack = JSON.parse(newCodes) || [];
      }
    );
    $rootScope.$watch(
      function () {
        return $window.localStorage.getItem("cart.orderItems");
      },
      function (newCodes, oldCodes) {
        $rootScope.OrderItems = JSON.parse(newCodes) || [];
      }
    );
    $scope.getCustomerTypeDescription = function (typeID) {
      console.log("getCustomerTypeDescription", typeID);
      if (typeID == 0) {
        typeID = 2;
      }
      if (
        $rootScope.ClientSettings &&
        $rootScope.ClientSettings.CustomerTypes
      ) {
        var Des = $rootScope.ClientSettings.CustomerTypes.filter(function (
          customerTypes
        ) {
          return customerTypes.ID == typeID;
        })[0].Description;
        console.log("getCustomerTypeDescription", Des);
        return Des;
      }
    };
    $rootScope.$watch(
      function () {
        return $window.localStorage.getItem("cart.autoship");
      },
      function (newCodes, oldCodes) {
        //$rootScope.AutoshipItems = JSON.parse(newCodes) || [];
        console.log("autoshipitem");
      }
    );
    $rootScope.$watch(
      function () {
        return $window.localStorage.getItem("enrollerinfo");
      },
      function (newCodes, oldCodes) {
        $rootScope.EnrollerInfo = JSON.parse(newCodes) || [];
        console.log("EnrollerInfo");
      }
    );
    $scope.changeFrequency = function (frequency) {
      $scope.selectedFrequency = frequency;
    };
    $("#frequencyStartDate").bind("input", function () {
      $scope.frequnecyStartDate = $(this).val(); // get the current value of the input field.
    });

    /* ********************************************************
		@ Add (Referral = Webalias) on every single page
	******************************************************** */

    const addDefaultQueryParams = () => {
      try {
        const webAlias = localStorage.getItem("enrollerinfo")
          ? JSON.parse(localStorage.getItem("enrollerinfo")).WebAlias
          : localStorage.getItem("ALS") || "";
        var url = new URL($window.location.href);
        if (url.searchParams.get("referral")) {
          return;
        } else if (webAlias) {
          url.searchParams.set("referral", webAlias);
          $window.history.pushState(null, "", url);
          $window.location.href = url.href;
        }
      } catch (error) {
        console.error(error);
      }
    };

    addDefaultQueryParams();

    /* ***************** END *********************************/

    $scope.updateCustomerType = function (customerType) {
      if (customerType == sessionStorage.getItem("customerType")) return;
      swal(
        {
          html: true,
          title: "",
          text: '<div class="cnf_cus_type"><h3 class="mb-3">Update Customer Type </h3> <p>Updating Existing Customer Type Will Impact Existing Customer Cart Item</p></div>',
          showCancelButton: true,
          confirmButtonText: "YES",
          closeOnConfirm: true,
          confirmButtonClass: "btn btn-theme",
          cancelButtonClass: "",
          cancelButtonText: "NO",
        },
        function (confirm) {
          if (confirm) {
            localStorage.setItem("cart.packs", "[]");
            localStorage.setItem("cart.order", "[]");
            localStorage.setItem("cart.autoship", "[]");
            document.cookie =
              "cart" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            sessionStorage.setItem("customerType", customerType);
            const params = new URLSearchParams(location.search);
            params.set("type", customerType);
            window.history.replaceState({}, "", `/collections/all?${params}`);
            window.location.reload();
          }
        }
      );
    };

    if (localStorage.getItem("customerData")) {
      $rootScope.UserData = JSON.parse(localStorage.getItem("customerData"));
    } else {
      var enrollment = {
        mailingAddress: {
          FirstName: "test",
          LastName: "test",
          StreetAddress: "770 E M",
          Apartment: "Test",
          City: "Lehi",
          State: "UT",
          ZipCode: "84043",
          Contact: "9667191786",
        },
      };
      $rootScope.UserData = {
        MainAddress1: enrollment.mailingAddress.StreetAddress,
        MainAddress2: enrollment.mailingAddress.Apartment,
        MainAddress3: "",
        MainCity: enrollment.mailingAddress.City,
        MainCountry: "enrollment.mailingAddress.Country",
        MainZip: enrollment.mailingAddress.ZipCode,
        MainState: enrollment.mailingAddress.State,
        LanguageCode: "en",
      };
    }
    $scope.CalculateOrder = function () {
      var Details = [];
      console.log("callcalculateorder AppCtrl");
      jQuery.getJSON("/cart.js", function (cart) {
        jQuery.get("/cart?view=data", function (cart) {});
        cart.items.forEach(function (element) {
          var itemQuantityArray = [];
          if (
            element.properties.discoitemid &&
            parseInt(element.quantity, 10) > 0
          ) {
            var iskitItem = $rootScope.EnrollmentPack.some(function (
              packelement
            ) {
              if (packelement.id === element.id) {
                itemQuantityArray.push({
                  ordertype: "pack",
                  quantity: packelement.quantity,
                });
                if (element.quantity > packelement.quantity) {
                  itemQuantityArray.push({
                    ordertype: "order",
                    quantity: element.quantity - packelement.quantity,
                  });
                }
                return true;
              } else {
                return false;
              }
            });
            if (!iskitItem) {
              console.log("sdasdasdas", itemQuantityArray);
              itemQuantityArray.push({
                ordertype: "order",
                quantity: element.quantity,
              });
            }
            itemQuantityArray.forEach(function (item) {
              Details.push({
                CurrencyCode: "USD",
                ItemCode: element.properties.discoitemid,
                Sku: element.properties.discoitemid,
                IskitItem: item.ordertype == "pack" ? true : false,
                Quantity: parseInt(item.quantity, 10),
                VariantID: element.variant_id,
              });
            });
          }
        });
        var calculateOrderRequest = {
          Address1: $rootScope.UserData.MainAddress1, //$scope.enrollment.shippingAddress.StreetAddress,
          Address2: $rootScope.UserData.MainAddress2, //$scope.enrollment.shippingAddress.Apartment,
          Address3: $rootScope.UserData.MainAddress3,
          City: $rootScope.UserData.MainCity,
          Country: $rootScope.UserData.MainCountry,
          CouponCodes: [],
          CurrencyCode: "USD",
          ShipMethodID: 0,
          StoreID: 3,
          PriceTypeID:
            $rootScope.UserData.CustomerTypeID ||
            sessionStorage.getItem("customerType") ||
            2,
          CustomerId: 0,
          CustomerType:
            $rootScope.UserData.CustomerTypeID ||
            sessionStorage.getItem("customerType") ||
            2,
          Details: Details,
          OrderType: 1,
          State: $rootScope.UserData.MainState,
          Zip: $rootScope.UserData.MainZip,
          Language: $rootScope.UserData.LanguageCode || "en",
        };
        console.log("callcalculateorder AppCtrl");
        window.DI.Enrollment.calculateorder(calculateOrderRequest).then(
          function (response, error) {
            if (response && response.Status == 1 && response.Data) {
              console.log("callcalculateorder AppCtrl", response.Data);
              calculateService.calculateOrderResponse = response.Data;
              //$scope.getcartitem();
              $scope.$apply();
            } else {
              window.DI.DI.notification(
                "Error",
                "Something Wrong With Your Cart Item Please Remove Them one By One",
                "error"
              );
            }
          }
        );
      });
    };

    $scope.CalculateAutoOrder = function () {
      var Details = [];
      console.log("CalculateAutoOrder AppCtrl");
      var autoshipItems =
        JSON.parse(localStorage.getItem("cart.autoship")) || [];
      if (autoshipItems && autoshipItems.length > 0) {
        // autoshipItems.forEach(autoshipitem => {
        // 	jQuery.getJSON('/products/' + autoshipitem.handle, function (product) {
        // 		autoshipitem.itemDetail = product;
        // 	});
        // });
        var Details = [];
        autoshipItems.forEach((element) => {
          if (
            element.properties.discoitemid &&
            parseInt(element.quantity, 10) > 0
          ) {
            Details.push({
              CurrencyCode: "USD",
              ItemCode: element.properties.discoitemid,
              IskitItem: false,
              Quantity: parseInt(element.quantity, 10),
            });
          }
        });
        var calculateAutoOrderRequest = {
          Address1: $rootScope.UserData.MainAddress1, //$scope.enrollment.shippingAddress.StreetAddress,
          Address2: $rootScope.UserData.MainAddress2, //$scope.enrollment.shippingAddress.Apartment,
          Address3: $rootScope.UserData.MainAddress3,
          City: $rootScope.UserData.MainCity,
          Country: $rootScope.UserData.MainCountry,
          CouponCodes: [],
          CurrencyCode: "USD",
          ShipMethodID: 0,
          StoreID: 3,
          PriceTypeID:
            $rootScope.UserData.CustomerTypeID ||
            sessionStorage.getItem("customerType") ||
            2,
          CustomerId: 0,
          CustomerType:
            $rootScope.UserData.CustomerTypeID ||
            sessionStorage.getItem("customerType") ||
            2,
          Details: Details,
          OrderType: 2,
          State: $rootScope.UserData.MainState,
          Zip: $rootScope.UserData.MainZip,
          Language: $rootScope.UserData.LanguageCode || "en",
        };
        console.log("calculateAutoOrderRequest AppCtrl");
        window.DI.Enrollment.calculateautoorder(calculateAutoOrderRequest).then(
          function (response, error) {
            console.log("calculateAutoOrderRequest AppCtrl", response);
            console.log("calculateAutoOrderRequest AppCtrl", error);
            calculateService.calculateAutoOrderResponse = response.Data;
            $scope.getautoshipcartitem();
            $scope.$apply();
          }
        );
      } else {
        calculateService.calculateAutoOrderResponse = {};
        $scope.getautoshipcartitem();
      }
    };
    $scope.getcartitem = function () {
      jQuery.getJSON("/cart.js", function (cart) {
        $scope.cartItems = [];
        cart.items.forEach(function (element) {
          var iskitItem = false;
          $rootScope.EnrollmentPack =
            $rootScope.EnrollmentPack ||
            JSON.parse(localStorage.getItem("cart.packs") || "[]") ||
            [];
          iskitItem = $rootScope.EnrollmentPack.some(function (pack) {
            return pack.id === element.id;
          });
          if (iskitItem == true) {
            $rootScope.EnrollmentPack.forEach(function (packelement) {
              if (packelement.id === element.id) {
                element.showinorder =
                  element.quantity - packelement.quantity > 0 ? true : false;
                console.log(
                  "cartitem.packquantitycartitem.packquantitycartitem.packquantity"
                );
                element.quantity = element.quantity - packelement.quantity;
                element.packquantity = packelement.quantity;
                element.ispackitem = true;
              }
            });
          } else {
            element.showinorder = true;
            element.quantity = element.quantity;
            element.packquantity = 0;
            element.ispackitem = false;
          }
          $scope.cartItems.push(element);
        });
        console.log("isContainOrderItem");
        if (
          !localStorage.getItem("cart.packs") &&
          !localStorage.getItem("cart.order")
        ) {
          localStorage.setItem("cart.order", JSON.stringify($scope.cartItems));
        }
        $rootScope.isContainOrderItem =
          JSON.parse(localStorage.getItem("cart.order") || "[]").length > 0
            ? true
            : false;
        // $scope.cartItems.some(function (packelement) {
        // 	console.log('isContainOrderItem',$rootScope.EnrollmentPack.length);
        // 	if (packelement.showinorder || $rootScope.EnrollmentPack.length==0) {
        // 		return true;
        // 	} else{
        //         return false;
        //     }
        // });
        sideBarService.setItems($scope.cartItems);
        $scope.$apply();
      });
    };
    $scope.getautoshipcartitem = function () {
      setTimeout(function () {
        $rootScope.AutoshipItems =
          JSON.parse(localStorage.getItem("cart.autoship")) || [];
        $scope.$apply();
      }, 200);
    };

    // $scope.getcartitem();
    // $scope.getautoshipcartitem();
    // if (window.location.pathname.indexOf('pages/enrollment') < 0 && window.location.pathname.indexOf('pages/checkout') < 0) {
    // 	console.log('CalculateAutoOrder AppCtrl');
    // 	$scope.CalculateAutoOrder();
    // }
    // $rootScope.$on('callcalculateorder', function () {
    // 	if (window.location.pathname.indexOf('pages/enrollment') < 0 && window.location.pathname.indexOf('pages/checkout') < 0) {
    // 		$scope.CalculateOrder();
    // 	}
    // });
    // $rootScope.$on('callcalculateautoorder', function () {
    // 	if (window.location.pathname.indexOf('pages/enrollment') < 0 && window.location.pathname.indexOf('pages/checkout') < 0) {
    // 		console.log('CalculateAutoOrder AppCtrl');
    // 		$scope.CalculateAutoOrder();
    // 	}
    // });
    // if (window.location.pathname.indexOf('pages/enrollment') < 0 && window.location.pathname.indexOf('pages/checkout') < 0) {
    // 	$scope.CalculateOrder();
    // }
    // if (window.location.pathname.indexOf('pages/enrollment') < 0 && window.location.pathname.indexOf('pages/checkout') < 0) {
    // 	$scope.CalculateAutoOrder();
    // }

   $scope.setConsultantCheckoutEnrollment = function(selectedSponsor) {
	 sessionStorage.setItem('sponsorSearch', selectedSponsor.WebAliases[0]);
	 $scope.SelectedSponsor = selectedSponsor;
	  $scope.SetSponsor();
     
 }
    
     $scope.setConsultantCheckout = function(selectedSponsor) {
	 console.log("test 1", selectedSponsor);
	 $scope.SelectedSponsor = selectedSponsor;
	 console.log("test 2", $scope.SelectedSponsor);
	  $scope.SetSponsor();
 }

        $scope.SetSponsor = function () {
          if ($scope.SelectedSponsor && $scope.SelectedSponsor.BackOfficeId) {
            $rootScope.showLoader();
            window.DI.Users.getcustomersitebyid($scope.SelectedSponsor.BackOfficeId)
              .then(function (result) {
                if (result.Data && (result.Data.Webalias ?? result.Data.Username)) {
                  const url = new URL(location.href);
                  url.searchParams.set("referral", result.Data.Webalias ?? result.Data.Username);
                  history.pushState(null, "", url);
                   if (window.location.href.includes('/login')) {
                      console.log("Page has login in the url");
                   }
                  if (!window.location.href.includes('/account/login')) {
                    window.location.reload();
                  } else {
                    window.DI.DI.notification("Success", "Sponsor Updated", "success");
                  }
                } else {
                  window.DI.DI.notification("Error", "Webalias Not Exist", "error");
                }
                $rootScope.hideLoader();
              })
              .catch((error) => {
                window.DI.DI.notification("Error", "Something went wrong!", "error");
                $rootScope.hideLoader();
              });
          } else {
            window.DI.DI.notification("Error", "Select Any Sponsor", "error");
          }
        };

    
    $scope.navigateToChangeAffiliate = function () {
      $rootScope.showLoader();
      $.get("/search?q=&view=find-enroller")
        .then(function (response) {
          var template = $templateCache.put("findenroller.html", response);
          $uibModal.open({
            animation: true,
            templateUrl: "findenroller.html",
            backdrop: "static",
            keyboard: true,
            closeOnEscape: false,
            windowClass: "uibmodalclass",
            controller: [
              "$rootScope",
              "$scope",
              "$uibModalInstance",
              function ($rootScope, $scope, $uibModalInstance) {
                $scope.title = "";
                $scope.message = "";
                $scope.type = "";
                $scope.data = "";
                $scope.updateClosedPopupValue = function () {
                  var closedPopupValue = sessionStorage.getItem('closedPopup');
                  if (closedPopupValue == null || closedPopupValue === '') {
                      sessionStorage.setItem('closedPopup', '1');
                  } else {
                      sessionStorage.setItem('closedPopup', '2');
                  }
              };
                $scope.close = function (isclose, arg) {
                  $uibModalInstance.dismiss("cancel");
                  
                };

                $scope.SearchSponsors = function () {
                  $rootScope.showLoader();
                  window.DI.Users.findenroller($scope.name).then(function (
                    result
                  ) {
                    try {
                      if (parseInt(result.Status, 10) === 1) {
                        var SearchList = result.Data;

                        // if (sessionStorage.getItem('customerType') == 1) {
                        // 	//Exclude AssociateTypes 2 and 3 from search results
                        SearchList = _.reject(SearchList, function (enroll) {
                          return (
                            enroll.AssociateType == 2 ||
                            enroll.AssociateType == 3 ||
                            enroll.StatusId != 1
                          );
                        });
                        // }

                        // if (sessionStorage.getItem('customerType') == 2) {
                        // 	//Exclude AssociateTypes 1 and 3 from search results
                        // 	SearchList = _.reject(SearchList, function (enroll) {
                        // 		return (
                        // 			enroll.AssociateType == 1 || enroll.AssociateType == 3
                        // 		);
                        // 	});
                        // }

                        // if (sessionStorage.getItem('customerType') == 3) {
                        // 	//Exclude AssociateTypes 1 and 2 from search results
                        // 	SearchList = _.reject(SearchList, function (enroll) {
                        // 		return (
                        // 			enroll.AssociateType == 1 || enroll.AssociateType == 2
                        // 		);
                        // 	});
                        // }

                        if (SearchList && SearchList.length > 0) {
                          $scope.Search = {};
                          $scope.IsSearchValidated = "";
                          $scope.SearchedSponsors = SearchList;
                          $scope.$apply();
                        } else {
                          $scope.Search = {};
                          $scope.IsSearchValidated = "";
                          window.DI.DI.notification(
                            "Info",
                            "No Record Found",
                            "error"
                          );
                        }
                      }
                      $rootScope.hideLoader();
                    } catch (error) {
                      $rootScope.hideLoader();
                    }
                  });
                };
                $scope.SelectSponsor = function (event, sponsor) {
                  console.log("event", event);
                  console.log("sponsor", sponsor);

                  $(".selected_sponsor").each(function () {
                    this.checked = false;
                  });
                  $(event.currentTarget)[0].checked = true;
                  $scope.SelectedSponsor = sponsor;
                console.log("Selected Sponsor:", sponsor);

                };

          $scope.SetSponsor = function () {
            if ($scope.SelectedSponsor && $scope.SelectedSponsor.BackOfficeId) {
              $rootScope.showLoader();
              window.DI.Users.getcustomersitebyid($scope.SelectedSponsor.BackOfficeId)
                .then(function (result) {
                  if (result.Data && (result.Data.Webalias ?? result.Data.Username)) {
                    const url = new URL(location.href);
                    url.searchParams.set("referral", result.Data.Webalias ?? result.Data.Username);
                    history.pushState(null, "", url);
                   if (window.location.href.includes('/login')) {
                      console.log("Page has login in the url");
                   }
                    if (!window.location.href.includes('/account/login')) {
                      window.location.reload();
                    } else {
                      window.DI.DI.notification("Success", "Sponsor Updated", "success");
                    }
                  } else {
                    window.DI.DI.notification("Error", "Webalias Not Exist", "error");
                  }
                  $rootScope.hideLoader();
                })
                .catch((error) => {
                  window.DI.DI.notification("Error", "Something went wrong!", "error");
                  $rootScope.hideLoader();
                });
            } else {
              window.DI.DI.notification("Error", "Select Any Sponsor", "error");
            }
          };


                $scope.SetDefaultSponsor = function () {
                  const url = new URL(location.href);
                  url.searchParams.set("referral", "OlivedaOrphan");
                  history.pushState(null, "", url);
                  $scope.close();
                  window.DI.DI.notification(
                    "Success",
                    "Sponsor Updated",
                    "success"
                  );
                  window.location.reload();
                };
              },
            ],
          });
          $rootScope.hideLoader();
        })
        .catch((error) => $rootScope.hideLoader());
    };

    $scope.navigateToContact = function () {
      console.log("sddfsd");
      $.get("/search?q=&view=contact").then(function (response) {
        var template = $templateCache.put("contact.html", response);
        $uibModal.open({
          animation: true,
          templateUrl: "contact.html",
          backdrop: "static",
          keyboard: true,
          closeOnEscape: false,
          windowClass: "",
          controller: [
            "$rootScope",
            "$scope",
            "$uibModalInstance",
            function ($rootScope, $scope, $uibModalInstance) {
              $scope.title = "";
              $scope.message = "";
              $scope.type = "";
              $scope.data = "";
              $(function () {
                $("body").addClass("contact-info-modal-dialog");
              });
              $scope.$on("$destroy", function () {
                $("body").removeClass("contact-info-modal-dialog");
              });
              $scope.close = function (isclose, arg) {
                $uibModalInstance.dismiss("cancel");
                
              };
            },
          ],
        });
      });
    };
    $scope.setDefaultAddress = function (id) {
      if (id > 0) {
        $("#address_default_address_" + id).trigger("click");
        $("#address_form_" + id).submit();
      }
    };

    $scope.handleSSOLogin = function () {
      let customerId;
    
      if (
        window.ShopifyAnalytics.meta.page.customerId != undefined &&
        window.ShopifyAnalytics.meta.page.customerId != null
      )


      
        customerId = window.ShopifyAnalytics.meta.page.customerId;
      else {
        //window.open("https://oliveda.office2.directscale.com", "_blank");
        window.location.href = "https://backoffice.olivetreepeople.com";
        return;
      }


      if (customerId > 0) {
        $("#vjenroll-loading").css("display", "block");
        let request = {
          externalId: customerId,
        };

        $.ajax({
          url: `https://eusync.connectolive.com/SSO`,
          type: "POST",
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify(request),
          success: function (response) {
            if (response) {
              if (response.Data != null) {
                //window.open(response.Data, "_blank");
                window.location.href = response.Data;
              } else {
                //window.open("https://backoffice.olivetreepeople.com", "_blank");
                window.location.href = "https://backoffice.olivetreepeople.com";
              }
            }
            $("#vjenroll-loading").css("display", "none");
          },
          error: function (error) {
            $("#vjenroll-loading").css("display", "none");
            //window.open("https://backoffice.olivetreepeople.com", "_blank");
            window.location.href = "https://backoffice.olivetreepeople.com";
          },
        });
      } else {
        //window.open("https://backoffice.olivetreepeople.com", "_blank");
        window.location.href = "https://backoffice.olivetreepeople.com";
      }
    };

    /* -------------------------------------------------------
		CHECK WHETHER ON ENROLLMENT PAGE
	------------------------------------------------------- */

    $scope.onEnrollmentPage = false;
    (function checkCurrentPage() {
      if (window.location.pathname.includes("enrollment")) {
        $scope.onEnrollmentPage = true;
      }
    })();

    /* -------------------------------------------------------
		DISPLAYING SPONSOR DETAILS ON HEADER
	------------------------------------------------------- */

    $(document).ready(() => {
      $scope.handleSponsorHeaderDisplay();
      const pathname = window.location.pathname;
      if(pathname == '/' || pathname == '/cart' || pathname == '/pages/join-us'){
      	var enrollInfo = localStorage.getItem("enrollerinfo");
	      if (enrollInfo == "null" && (!getParameterByName('referral') || getParameterByName('referral') == 'OlivedaOrphan')) {
	        setTimeout(function () {
	         // $scope.navigateToChangeAffiliate();
	        }, 1000);
	    }
      } 
    });

    $scope.handleSponsorHeaderDisplay = function () {
      if ($rootScope.EnrollerInfo.WebAlias) {
        $(".sponsor_details-section").addClass("d-flex");
        $(".sponsor_details-section").removeClass("d-none");
      } else {
        $(".no-sponsor-section").addClass("d-flex");
        $(".no-sponsor-section").removeClass("d-none");
      }
    };

    getParameterByName = function (name) {
      query = window.location.search.toString();
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      results = regex.exec(query);
      if (results === null) return "";
      else return decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    /* -------------------------------------------------------
      Register Account in Shopify from /account/register
    ------------------------------------------------------- */

    $scope.saveUserMetafields = function(sourcePage){
      return;
      let emailAddress = "";

      if (sourcePage == "register"){
        emailAddress = document.getElementById("RegisterForm-email").value ?? "";
      }

      if(sourcePage == "newsletter-1"){
        emailAddress = document.getElementById("NewsletterForm-Desktop-email").value ?? "";
      }
      
      if(sourcePage == "newsletter-2"){
        emailAddress = document.getElementById("NewsletterForm-Mobile-email").value ?? "";
      }

      var filter = new RegExp("^([\\w-\\.+]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\\]?)$");

      if (emailAddress && filter.test(emailAddress)) {
        let request = {
          "checkoutType": "retail",
          "email": emailAddress,
          "sponsorId": $rootScope.EnrollerInfo ? $rootScope.EnrollerInfo.AssociateID : 0 || 0,
          "internalKey": 'xyz'
        }

        window.DI.Enrollment.saveCustomFields(request)
        .then((response) => {
            if(response == true){

              if (sourcePage == "register"){
                document.getElementById("RegisterForm-SubmitButton").click();
              }
        
              if(sourcePage == "newsletter-1"){
                document.getElementById("NewsletterForm-Desktop-SubmitButton").click();
              }
              
              if(sourcePage == "newsletter-2"){
                document.getElementById("NewsletterForm-Mobile-SubmitButton").click();
              }

            }
        })
        .catch((error) => {});
      }
    }

  },
]);
